module.exports = __webpack_public_path__ + "static/media/logo_white.70bbc310.svg";